module.exports = __webpack_public_path__ + "img/carousel-1-1.11490b81.jpg";